const CryptoJS = require("crypto-js");

let key = null
let iv = null

// crypto_generate_key_f
export const crypto_generate_key_f = () => {
    key = CryptoJS.enc.Hex.parse("253D3FB468A0E24677C28A624BE0F939");
    iv  = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");
}

// crypto_encrypt_fs
export const crypto_encrypt_fs = (obj) => {

    if(key == null){
        crypto_generate_key_f()
    }

    if(obj == null || obj == ''){
        return obj
    }
    let encrypt = CryptoJS.AES.encrypt(JSON.stringify(obj), key, {iv: iv})

    return encrypt.toString();
}

// crypto_decrypt_fs
export const crypto_decrypt_fs = (encrypted_s) => {

    if(encrypted_s == null || encrypted_s == ''){
        return encrypted_s
    }

    if(key == null){
        crypto_generate_key_f()
    }
    let decrypted = CryptoJS.AES.decrypt(encrypted_s, key, {iv: iv});
    let decrypted_str = decrypted.toString(CryptoJS.enc.Utf8)

    return JSON.parse(decrypted_str)
}